import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './brokerage-charges.css'

const BrokerageCharges = (props) => {
  return (
    <div
      id={props.brokerageChargesId}
      className={`brokerage-charges-container1 thq-section-padding ${props.rootClassName} `}
    >
      <div className="brokerage-charges-max-width thq-section-max-width">
        <div className="brokerage-charges-container2 thq-grid-2">
          <div className="brokerage-charges-section-header">
            <h2 className="brokerage-charges-text10 thq-heading-2">
              Brokerage Charges
            </h2>
            <p className="brokerage-charges-text11 thq-body-large">
            Real estate transactions demand a delicate balance of professionalism, ethical conduct, trust, and transparency. At Omshashvath Global Realty India Private Limited, we are committed to simplifying the complexities of real estate while delivering exceptional value to our esteemed clients. Our brokerage charges are meticulously structured to ensure clarity, fairness, and complete transparency, guaranteeing that every transaction is conducted with the utmost integrity.
            </p>
            <div className="brokerage-charges-actions">
              <button className="thq-button-animated thq-button-filled brokerage-charges-button">
                <span className="thq-body-small">Know more</span>
              </button>
            </div>
          </div>
          <div className="brokerage-charges-container3">
            <div className="brokerage-charges-container4 thq-card">
              <h2 className="thq-heading-2">
                {props.step1Title ?? (
                  <Fragment>
                    <span className="brokerage-charges-text25">
                      Search Properties
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="brokerage-charges-text14 thq-body-small">
                {props.step1Description ?? (
                  <Fragment>
                    <span className="brokerage-charges-text28">
                      Browse through our extensive list of properties to find
                      your dream home.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="brokerage-charges-text15 thq-heading-3">
                01
              </label>
            </div>
            <div className="brokerage-charges-container5 thq-card">
              <h2 className="thq-heading-2">
                {props.step2Title ?? (
                  <Fragment>
                    <span className="brokerage-charges-text26">
                      Virtual Tours
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="brokerage-charges-text17 thq-body-small">
                {props.step2Description ?? (
                  <Fragment>
                    <span className="brokerage-charges-text32">
                      Take virtual tours of the properties you are interested in
                      from the comfort of your own home.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="brokerage-charges-text18 thq-heading-3">
                02
              </label>
            </div>
            <div className="brokerage-charges-container6 thq-card">
              <h2 className="thq-heading-2">
                {props.step3Title ?? (
                  <Fragment>
                    <span className="brokerage-charges-text29">
                      Market Insights
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="brokerage-charges-text20 thq-body-small">
                {props.step3Description ?? (
                  <Fragment>
                    <span className="brokerage-charges-text27">
                      Stay informed with the latest market trends and insights
                      to make well-informed decisions.
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="brokerage-charges-text21 thq-heading-3">
                03
              </label>
            </div>
            <div className="brokerage-charges-container7 thq-card">
              <h2 className="thq-heading-2">
                {props.step4Title ?? (
                  <Fragment>
                    <span className="brokerage-charges-text30">Contact Us</span>
                  </Fragment>
                )}
              </h2>
              <span className="brokerage-charges-text23 thq-body-small">
                {props.step4Description ?? (
                  <Fragment>
                    <span className="brokerage-charges-text31">
                      Reach out to us for any inquiries or assistance. We are
                      here to help!
                    </span>
                  </Fragment>
                )}
              </span>
              <label className="brokerage-charges-text24 thq-heading-3">
                04
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

BrokerageCharges.defaultProps = {
  step1Title: undefined,
  step2Title: undefined,
  step3Description: undefined,
  step1Description: undefined,
  step3Title: undefined,
  rootClassName: '',
  step4Title: undefined,
  step4Description: undefined,
  step2Description: undefined,
  brokerageChargesId: '',
}

BrokerageCharges.propTypes = {
  step1Title: PropTypes.element,
  step2Title: PropTypes.element,
  step3Description: PropTypes.element,
  step1Description: PropTypes.element,
  step3Title: PropTypes.element,
  rootClassName: PropTypes.string,
  step4Title: PropTypes.element,
  step4Description: PropTypes.element,
  step2Description: PropTypes.element,
  brokerageChargesId: PropTypes.string,
}

export default BrokerageCharges
